<ng-container *ngIf="currentItem$ | async as viewedIndex">
    <ng-container *ngFor="let item of steps$ | async; let i = index; trackBy:trackByFn; let last = last">
        <div *ngIf="tabsTitles$ | async as tabTitles" [ngClass]="{
         'blue': i<=activeIndex && tabTitles.includes(stepToTabAdapter[item.originalName]),
         'no-border': last && i>activeIndex,
         'done': i<activeIndex
         }"
             class="step">
            <div #stepHeader (click)="i<=activeIndex && stepClicked(stepToTabAdapter[item.originalName], i)"
                 [ngClass]="{'bold': i === viewedIndex.index}"
                 class="pathway-stepHeader">
                {{item.name}}
            </div>
            <ng-container [ngSwitch]="item.originalName">
                <ispm-pathway-steps-list *ngSwitchCase="'Select pathway'" [needKeepPrevious]="isNeedKeepPreviousPath()"></ispm-pathway-steps-list>
                <ispm-pathway-treatments-list *ngSwitchCase="'Select treatment'"
                                              [revision]="currentRevision"></ispm-pathway-treatments-list>
                <ng-container *ngIf="i<=activeIndex">
                    <ispm-pathway-documents-list (documentClicked)="stepClicked(stepToTabAdapter[item.originalName], i)"
                                                 *ngSwitchCase="'Signoff'"></ispm-pathway-documents-list>
                </ng-container>
                <ng-container *ngIf="isStepHasConfirmButton(item)">
                    <gen-step-confirmation-button 
                         [currentRevision]="currentRevision"
                         [currentWorkflow]="currentWorkflow">
                    </gen-step-confirmation-button>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-container>
